// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","SpacingMD":"15px","button":"Gcb073e"};